<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Movimientos</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <div class="row mb-3">
        <div class="col-md-8 col-lg-6">
          <aph-custom-date-picker 
            [singleMode]="false" 
            labelInicio="Fecha inicial"
            labelFin="Fecha final"
            [maxDate]="today"
            mode="date"
            [IsDisabledAll]="downloading"
            (startDateChange)="minDate = $event"
            (endDateChange)="maxDate = $event"
            (onValidationStatus)="esValidoRango = $event">
          </aph-custom-date-picker>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-4 col-lg-3">
          <label>Organizaci&oacute;n</label>
          <aph-custom-select
            [items]="organizacionList"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Seleccione --"
            [selectedValue]="orgSelected"
            (returnValue)="orgSelected = $event; changeFilterMovType2()">
          </aph-custom-select>
        </div>
        <div class="col-md-4 col-lg-3">
          <label>Regi&oacute;n</label>
          <aph-custom-select
            [items]="regionList"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Seleccione --"
            [selectedValue]="regSelected"
            (returnValue)="regSelected = $event; changeFilterMovType3()">
          </aph-custom-select>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-md-4 col-lg-3">
          <label>Nodo</label>
          <aph-custom-select
            [items]="moveList"
            bindLabel="UnitDes"
            bindValue="UnitId"
            type="default"
            placeholder="Todos"
            [selectedValue]="moveSelected"
            (returnValue)="moveSelected = $event">
          </aph-custom-select>
        </div>
        <div class="col-md-4 col-lg-3">
          <label>Tipo Movimiento</label>
          <aph-custom-select
            [items]="moveList2"
            bindLabel="Description"
            bindValue="MovementType"
            type="default"
            placeholder="Todos"
            [selectedValue]="moveSelected2"
            (returnValue)="moveSelected2 = $event">
          </aph-custom-select>
        </div>
      </div>

      <hr>

      <div class="row mt-4">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" 
            [label]="downloading ? 'Procesando...' : 'Descargar reporte'" 
            [loading]="downloading"
            [disabled]="downloading || !esValidoRango"
            (btnClick)="download()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>